<template>
  
</template>

<script>

/**
 * Vue: collection-50 (collection-50)
 * -----------------------------------------------------------------------------
 * New section for description.
 *
 * @param {String} liquid.sectionId - Section's Liquid ID.
 *
 */
export default {
  name: 'Collection50',

  props: {
    liquid: {
      type: Object,
      default: () => ({
        sectionId: '',
      }),
    },
  },

  data() {
    return {

    }
  },

  mounted() {
    // Not empty
  },

  methods: {
    // Not empty
  },
}
</script>

<style lang="scss">
@import './collection-50';
</style>
